'use client';

import { type FC, memo } from 'react';

import { Container, Rect } from '@/components/Skeleton';
import { useGetCommonStore } from '@/store';

export const HeaderSkeleton: FC = memo(() => {
  const useCommonStore = useGetCommonStore();
  const isMobileDevice = useCommonStore.use.isMobileDevice();
  return (
    <Container position="absolute" zIndex={23}>
      <Rect height={isMobileDevice ? 56 : 72} width="100%" />
    </Container>
  );
});
